import { useMemo } from 'react';
import { useAuth } from './AuthProvider.js';
import { useMasters } from '../data/queries.js';

// T-403 (Bluecoop modello a zone): la "zona" è `businesses.city`. Il mondo
// operativo di una sede sono tutte le sedi del tenant con la stessa città
// (es. Stabilimento + Magazzino di Favara): ordini preposti, piani, stampe e
// DDT di una zona restano in quella zona. I consumer zone-aware (Pianifica,
// stampa piatti-zona, picker destinazioni/DDT, anagrafica destinazioni)
// filtrano su queste sedi.
//
// Fail-open PER SCELTA: se la sede attiva non ha città (tenant mono-sede,
// tenant non-collettiva, dati non ancora migrati) → zoneIds = null = nessun
// filtro, comportamento tenant-wide identico a prima. Con una sola zona il
// filtro equivale al tenant-wide; i mondi si separano da soli quando compare
// una seconda città (apertura Sciacca: basta creare le sedi con city=Sciacca
// e ri-agganciare le destinazioni, zero codice).

interface ZoneBusinessRow {
  id: string;
  tenant_id: string;
  name: string;
  city?: string | null;
  archived_at?: string | null;
}

export function useZoneBusinesses(): { zoneIds: string[] | null; zoneName: string | null } {
  const { profile } = useAuth();
  const { data: businesses = [] } = useMasters<ZoneBusinessRow>('businesses');
  const tenantId = profile?.active_tenant_id ?? null;
  const activeBusinessId = profile?.active_business_id ?? null;

  return useMemo(() => {
    if (!tenantId || !activeBusinessId) return { zoneIds: null, zoneName: null };
    const mine = businesses.filter((b) => b.tenant_id === tenantId && !b.archived_at);
    const active = mine.find((b) => b.id === activeBusinessId);
    const city = active?.city?.trim();
    if (!city) return { zoneIds: null, zoneName: null };
    const norm = city.toLowerCase();
    const ids = mine.filter((b) => (b.city ?? '').trim().toLowerCase() === norm).map((b) => b.id);
    return { zoneIds: ids, zoneName: city };
  }, [businesses, tenantId, activeBusinessId]);
}
